import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptKeyShouts } from "../adapters/adaptKeyShouts";

const fetchKeyShouts = async (published: boolean) => {
	const response = await cmsClient.get<IKeyShout[]>(
		"/homepage/admin/keyshout/",
		{
			params: { published }
		}
	);

	return response.data;
};

const useKeyShouts = (published: boolean) => {
	const query = useQuery(
		["key-shouts", published],
		() => fetchKeyShouts(published),
		{
			select: adaptKeyShouts
		}
	);

	return query;
};

export default useKeyShouts;
